import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";

import { Location, VwwLocation } from "../models/location";

@Injectable({
  providedIn: "root",
})
export class LocationService extends BaseService<Location, Location> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "location");
  }

  getLocationByPostcode(postcode: string, organizationId?: number): Observable<Location> {
    let url = "/getlocationByPostcode?postcode=" + postcode;
    if (organizationId) {
      url += "&organizationId=" + organizationId;
    }
    return this.get(url);
  }

  getLocationSuggestions(qry: string): Observable<LocationSuggestion> {
    return this.http.get<LocationSuggestion>(
      "https://geo.api.vlaanderen.be/geolocation/v4/Suggestion?c=50&q=" + qry
    );
  }

  getAddress(qry: string): Observable<LocationAddressResult> {
    return this.http.get<LocationAddressResult>(
      "https://geo.api.vlaanderen.be/geolocation/v4/Location?q=" + qry
    );
  }

  getByCity(city: string): Observable<VwwLocation[]> {
    return this.http.get<any>(
      "https://api.vrijwilligerswerk.be/Location?$filter=contains(Name, '" + city + "')"
    );
  }
}

interface LocationSuggestion {
  SuggestionResult: string[];
}

interface LocationAddressResult {
  LocationResult: LocationAddress[];
}
interface LocationAddress {
  Municipality: string | null;
  Zipcode: string | null;
  Thoroughfarename: string | null;
  Housenumber: string | null;
  ID: number | null;
  FormattedAddress: string | null;
  Location: Coordinates | null;
  LocationType: string | null;
  BoundingBox: BoundingBox | null;
}
interface Coordinates {
  Lat_WGS84: number | null;
  Lon_WGS84: number | null;
  X_Lambert72: number | null;
  Y_Lambert72: number | null;
}

interface BoundingBox {
  LowerLeft: Location | null;
  UpperRight: Location | null;
}
